import { SidebarNavLink } from "@/components/ui/sidebar/sidebar-nav";
import { cn } from "@/lib/utils";
import { SidebarLinkProps } from "./types";

export const SidebarLink = ({ item, isActive, isDisabled, onClick, className }: SidebarLinkProps) => {
  return (
    <SidebarNavLink
      to={item.href}
      icon={item.icon}
      active={isActive}
      onClick={onClick}
      className={cn(
        "flex-1",
        className,
        isDisabled && "pointer-events-none opacity-50"
      )}
    >
      {item.name}
    </SidebarNavLink>
  );
};